module.exports = __webpack_public_path__ + "static/media/rappelb.2543e4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/rapeles_salto/rappelb.jpg
// module id = 19
// module chunks = 0